export default {
    'zakladna': {
        index: 0,
        title: 'Základny',
        url: 'bases',
        type: 'zakladna',
        properties: [
            {
                title: 'Sloupec',
                property: 'col',
                type: 'number',
                min: 1
            },
            {
                title: 'Název',
                property: 'name',
                type: 'text',
            },
            {
                title: 'Zkratka',
                property: 'abbreviation',
                type: 'text',
            },
            {
                title: 'GPS',
                property: 'gpsLatLng',
                type: 'gps',
            },
            {
                title: 'Odsazení',
                property: 'margin',
                type: 'number',
            },
			{
                title: 'Pořadí',
                property: 'order',
                type: 'number'
            }
        ]
    },
    'vsk': {
        index: 1,
        title: 'Výjezdové skupiny',
        url: 'crews',
        type: 'vsk',
        properties: [
            {
                title: 'Volací znak',
                property: 'volaciZnak',
                type: 'text',
            },
            {
                title: 'GPS',
                property: 'gpsLatLng',
                type: 'gps',
            },
            {
                title: 'Typ',
                property: 'type',
                type: 'text',
            },
            {
                title: 'Název',
                property: 'name',
                type: 'text',
            },
            {
                title: 'Počet výjezdů',
                property: 'pocetVyjezdu',
                type: 'number',
                min: 0,
            },
            {
                title: 'Základna',
                property: 'zakladna',
                type: 'number',
            },
			{
                title: 'Pořadí',
                property: 'order',
                type: 'number'
            }
        ]
    },
    'nemocnice': {
        index: 2,
        title: 'Nemocnice',
        url: 'hospitals',
        type: 'nemocnice',
        properties: [
            {
                title: 'Název',
                property: 'name',
                type: 'text',
            },
            {
                title: 'Zkratka',
                property: 'shortName',
                type: 'text',
            },
            {
                title: 'GPS',
                property: 'gpsLatLng',
                type: 'gps',
            },
            {
                title: 'Oddělení',
                property: 'oddeleni',
                type: 'tag',
            }
        ]
    },
    'oddeleni': {
        index: 3,
        title: 'Oddělení',
        url: 'departments',
        type: 'oddeleni',
        properties: [
            {
                title: 'Název',
                property: 'name',
                type: 'text',
            }
        ]
    },
    'predaniUdalosti': {
        index: 4,
        title: 'Předání události',
        url: 'forward',
        type: 'predaniUdalosti',
        properties: [
            {
                title: 'Pořadí',
                property: 'order',
                type: 'number'
            },
            {
                title: 'Název',
                property: 'name',
                type: 'text',
            }
        ]
    },
    'udalost': {
        index: 5,
        title: 'Událost',
        url: 'events',
        type: 'udalost',
        hideAddButton: true,
        properties: [
			{
                title: 'ID',
                property: 'cisloVyzvy',
                type: 'number'
            },
            {
                title: 'Čas vzniku',
                property: 'casVznikuRelative',
                type: 'casVzniku'
            },
			{
                title: 'Jméno pacienta',
                property: 'pacientJmeno',
                type: 'text'
            },
			{
                title: 'GPS',
                property: 'gpsLatLng',
                type: 'gps'
            },
            {
                title: 'Naléhavost',
                property: 'nalehavost',
                type: 'number'
            }
            
        ]
    }
};
